@if(isViewMyStoreType){

@if(storeStock()){
<app-my-store-stock [storeStock]="storeStock"></app-my-store-stock>
}@else {
<app-placeholder [message]="'No stock Available for This Store' | translate"></app-placeholder>
}

}

@if(isViewOtherStoreType){

@if(otherStoreStock().length > 0){

<app-other-store-stock [storeStocks]="otherStoreStock"></app-other-store-stock>

}@else {

<app-placeholder [message]="'No Other Store stock Available' | translate"></app-placeholder>

}

}
